import styled from 'styled-components';

export const AdContainer = styled.div(({ slideIn }) => {
  return `
  display: none;
  height: 0;
  width: 100%;
  transform: translateY(300px);
  transition: all 0.3s ease-out;
  transition-property: transform, height, width;

  @media (min-width: 1024px) {
    height: 100vh
    width: 0;
    transform: translateX(368px);
  }

  ${slideIn &&
    `
    height: 300px;
    width: 100%;
    transform: translateY(0);

    @media (min-width: 1024px) {
      height: 100vh;
      width: 368px;
      transform: translateX(0);
    }
  `}
`;
});
